import { render, staticRenderFns } from "./AccountantCustomersWidget.vue?vue&type=template&id=3d062374&"
import script from "./AccountantCustomersWidget.vue?vue&type=script&lang=js&"
export * from "./AccountantCustomersWidget.vue?vue&type=script&lang=js&"
import style0 from "./AccountantCustomersWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports